import { render, staticRenderFns } from "./VersionSnackbar.vue?vue&type=template&id=5164a3c5"
import script from "./VersionSnackbar.vue?vue&type=script&lang=ts"
export * from "./VersionSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports